/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';
import * as moment from 'moment';
import * as Pikaday from 'pikaday';

import * as $ from 'jquery';

angular.module('ticketspaceApp').factory('floatingCalendar', function () {
	// html is being added now, probably just pass it back on conclusion and the sender can parse out what they need
	function popCalendar(defaultDate, displayHtml, config) {
		if (!config) {
			config = {};
		}
		let cb = arguments[arguments.length - 1];

		let picker = new Pikaday({
			format: 'YYYY-MM-DD',
			defaultDate: moment(defaultDate, 'YYYY-MM-DD').toDate(),
			setDefaultDate: true,
			onSelect(date) {
				cb(moment(date).format('YYYY-MM-DD'), parsedDisplayHtml);
				picker.destroy();
				wrapper.remove();
			},
		});
		let wrapper = $('<div>');

		let calWrap = $('<div class="pika-wrap">');
		let parsedDisplayHtml = $(displayHtml);
		calWrap.append(parsedDisplayHtml);
		calWrap.append(picker.el);
		let closeButton = $('<button class="legacy-button btn--red">Clear current date</button>');

		if (!config.noDelete) {
			calWrap.append(closeButton);
		}
		closeButton.on('click', function (e) {
			cb(false);
			wrapper.off();
			picker.destroy();
			wrapper.remove();
		});

		wrapper.append(calWrap);

		wrapper.addClass('popup-wrapper popup-wrapper-shade');
		wrapper.on('click', function (e: any) {
			if (e.target != wrapper[0]) {
				return;
			}
			cb(defaultDate, parsedDisplayHtml);
			wrapper.off();
			picker.destroy();
			wrapper.remove();
		});
		$('body').append(wrapper);

		// MOC-3976 - Return a function that can be used to close the popup
		const off = function () {
			wrapper.off();
			picker.destroy();
			wrapper.remove();
		};

		return off;
	}

	return popCalendar;
});
